export const getVisibleCompanies = (organizations, visibleOrganizations, defaultStatus) => {
  if (defaultStatus === 'hide') {
    return organizations.map(item => {
      const matchedOrganization = visibleOrganizations.find(obj => obj.id === item.id);

      return {
        ...item,
        active: !visibleOrganizations?.length ? false : matchedOrganization ? true : false
      };
    });
  } else {
    return organizations.map(item => {
      const matchedOrganization = visibleOrganizations.find(obj => obj.id === item.id);

      return {
        ...item,
        active: !visibleOrganizations?.length || matchedOrganization
      };
    });
  }
};
